import React, { useState } from "react";
import { Button } from "antd";
import axios from "../shared/axios";


const baseURL = process.env.REACT_APP_BACKEND_URL;

const CancelInternalEnrolments = (props) => {

    const [message, setMessage] = useState("");

    const handleCancelInternalEnrolments = async () => {
        if (window.confirm("Are you sure you want to cancel all internal enrolments with the email @nasdaily.com or @nasacademy.com?")) {
            try {
                const response = await axios.post(`${baseURL}/unenroll-staff`);
                setMessage(JSON.stringify(response.data));
            } catch (error) {
                setMessage(error.message);
            }
        }
    };
    return (
        <>
            <Button onClick={handleCancelInternalEnrolments}>Cancel Internal Enrolments</Button>
            <p>{message}</p>
        </>
    )
};

export default CancelInternalEnrolments;
